import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UploadXHRArgs, UploadFile } from 'ng-zorro-antd';
import { _HttpClient } from '@delon/theme';
import { timeout } from 'rxjs/operators';
import { DialogService } from '../../services/dialog.service';
import { URLS } from '../../constant/interface';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-audio-upload',
  templateUrl: './icc-audio-upload.component.html',
  styleUrls: ['./icc-audio-upload.component.less'],
})
export class IccAudioUploadComponent implements OnInit {
  constructor(private http: _HttpClient, private dialogService: DialogService) {}

  // 上传地址
  @Input() nzAction: string;

  // 音频文件地址
  @Input() fileUrl: string;

  // 是否支持扩展格式，即支持 .amr / .mp3 / .m4a 格式，默认不支持，即只支持 .amr 格式
  @Input() isSupportExtendFormat: boolean = false;

  // 支持音频文件的大小限制，默认 2M
  @Input() fileSizeLimit: number = 2;

  // 是否禁用
  @Input() disabled = false;

  // 文件删除事件
  @Output() delete: EventEmitter<any> = new EventEmitter<any>();

  // 文件上传成功事件
  @Output() success: EventEmitter<any> = new EventEmitter<any>();

  // 文件列表
  nzFileList: Array<any>;

  beforeUpload = $event => {
    return this.nzBeforeUpload($event);
  };
  customRequest = $event => {
    this.nzCustomRequest($event);
  };

  ngOnInit() {}

  /*
   * nz-upload
   * 通过覆盖默认的上传行为，自定义自己的上传实现
   */
  nzBeforeUpload(file: UploadFile) {
    const fileName = file.name.toLocaleLowerCase();
    let _fileSzie = this.fileSizeLimit * 1024;
    let warnText: string;
    switch (true) {
      case !this.isSupportExtendFormat && !fileName.endsWith('.amr'):
        warnText = '音频文件仅支持AMR格式';
        break;
      case this.isSupportExtendFormat && (!fileName.endsWith('.amr') && !fileName.endsWith('.mp3') && !fileName.endsWith('.m4a')):
        warnText = '音频文件仅支持AMR、MP3、M4A格式';
        break;
      case file.size / 1024 > _fileSzie:
        warnText = `音频文件大小不能超过${this.fileSizeLimit}M`;
        break;
      case !this.nzAction:
        warnText = '请配置文件上传路径';
        break;
      default:
        break;
    }
    if (warnText) {
      this.dialogService.notification.warning('提示', warnText);
      return false;
    }
    return true;
  }

  /*
   * nz-upload
   * 通过覆盖默认的上传行为，自定义自己的上传实现
   */
  nzCustomRequest = (item: UploadXHRArgs) => {
    const formData = new FormData();
    formData.append('file', item.file as any);
    return this.http
      .post(item.action!, formData)
      .pipe(timeout(60000))
      .subscribe(
        event => {
          this.nzFileList = [];
          if (event && event.status === 0 && event.data) {
            this.fileUrl = URLS.attachment.url + '?module=5&path=' + event.data.filePath;
            this.success.emit(this.fileUrl);
          } else {
            this.dialogService.notification.error('错误', event.errorMsg);
            item.onError!(event.errorMsg, item.file!);
          }
        },
        err => {
          this.nzFileList = [];
          item.onError!(err, item.file!);
        },
      );
  };
  /*
   * 删除音频文件
   */
  removeAudio($event) {
    this.fileUrl = '';
    this.delete.emit($event);
  }
}
